import { render, staticRenderFns } from "./ProdutosBonusCard.vue?vue&type=template&id=261223f4&scoped=true"
import script from "./ProdutosBonusCard.vue?vue&type=script&lang=js"
export * from "./ProdutosBonusCard.vue?vue&type=script&lang=js"
import style0 from "./ProdutosBonusCard.vue?vue&type=style&index=0&id=261223f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261223f4",
  null
  
)

export default component.exports